
 

 

 

 
class CreatePasswordData 
{
    
        TokenKey: string;
    
        UserId: string;
    
        Password: string;
    
}
 
export default CreatePasswordData;
 




